module.exports = __webpack_public_path__ + "static/media/home_menu.f2af960d.svg";